import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  dialogTitle: {
    margin: 0,
    padding: "24px 32px",
  },
  iconButton: {
    position: "absolute",
    right: 8,
    top: 8,
    color: (theme: Theme) => theme.palette.grey[500],
  },
  dialogContent: {
    padding: "0 32px",
  },
  dialogActions: {
    padding: "16px 32px",
  },
};
